import { RefObject, useEffect, useRef, useState } from 'react'

// detectionPosition: inner화면 상단에서의 높이
const useContentsTopLevelDetection = (detectionPosition: number) => {
  const contentsRef: RefObject<HTMLDivElement> = useRef(null)
  const [detector, setDetector] = useState(false)

  useEffect(() => {
    const handleScroll = () => {
      if (contentsRef.current) {
        const { bottom } = contentsRef.current.getBoundingClientRect()
        setDetector(bottom !== 0 && bottom <= detectionPosition)
      }
    }

    window.addEventListener('scroll', handleScroll)
    return () => window.removeEventListener('scroll', handleScroll)
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [])

  return {
    contentsRef,
    detector,
  }
}
export default useContentsTopLevelDetection
